export default __webpack_public_path__ + "static/innovator-1--mobile-5bb858ee84823e164b699c5b6fbe3a59.webp";